import { ENTITY_LISTING_VIEW_TYPE } from '../../../../../constants/common'
import {
  getListViewTypeWithPreview,
  isListViewTypeBoard,
  isListViewTypeWithPreview,
} from '../../../../../utils/listViewType'
import {
  APPLICANT_PREVIEW_REGIME_AVAILABLE,
  APPLICANT_VIEW_TYPES,
} from '../../RentalPortalApplicants.constants'
import { getIsApplicantCompareViewType } from '../../RentalPortalApplicants.utils'

import { APPLICANTS_VIEW_PARAM } from './useRentalPortalApplicantsViewRegime.constants'

export function getApplicantsTableViewRegime(listViewType) {
  return APPLICANT_PREVIEW_REGIME_AVAILABLE &&
    isListViewTypeWithPreview(listViewType)
    ? getListViewTypeWithPreview(ENTITY_LISTING_VIEW_TYPE.table)
    : ENTITY_LISTING_VIEW_TYPE.table
}

export function getApplicantsViewRegime({
  hasStage,
  isCompareAvailable,
  searchParams,
}) {
  const view = searchParams.get(APPLICANTS_VIEW_PARAM)

  if (getIsApplicantCompareViewType(view)) {
    return isCompareAvailable ? view : getApplicantsTableViewRegime(view)
  }

  const isKnownView = APPLICANT_VIEW_TYPES.includes(view)

  const isBoardAllowed = hasStage || !isListViewTypeBoard(view)

  const isPreviewAllowed =
    APPLICANT_PREVIEW_REGIME_AVAILABLE || !isListViewTypeWithPreview(view)

  return isKnownView && isBoardAllowed && isPreviewAllowed
    ? view
    : getApplicantsTableViewRegime(view)
}
